// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__281hc","dragIcon":"Choice_dragIcon__RisMb","left":"Choice_left__1o3P4","input":"Choice_input__1k_k1"};